module.exports = __webpack_public_path__ + "assets/img/Record.52a93be2.png";